import { ColumnsType } from "antd/es/table";
import { boolean, object, string, array } from "yup";
import { DataType } from "./components/studentCharts";
export const reportsSchema = object({
  selection: string(),
  filter: boolean(),
  year: array().of(string()),
  term: array().of(string()),
  from: string(),
  to: string(),
  student: string(),
  course: array().of(string()),
});

export const reportsValues = () => {
  return {
    selection: "Program",
    filter: true,
    year: [],
    term: [],
    from: "",
    to: "",
    student: "",
    course: [],
  };
};

export const colorsSet = [
  "#8BC1F7",
  "#519DE9",
  "#06C",
  "#BDE2B9",
  "#7CC674",
  "#A2D9D9",
  "#F9E0A2",
  "#F4B678",
  "#C9190B",
  "#5EAD8E",
  "#F0A3A0",
  "#FCE5A2",
  "#D0E0E3",
  "#A3C86D",
  "#FFB84D",
  "#E27C7D",
  "#F2C94C",
  "#FFC1C1",
  "#C5E1A5",
  "#FFABAB",
  "#FFDAA5",
  "#AEEEEE",
  "#FFD700",
  "#B0E0E6",
  "#FF69B4",
  "#F5B7B1",
];

interface PIEChart {
  cx: number;
  cy: number;
  midAngle: number;
  innerRadius: number;
  outerRadius: number;
  percent: number;
}
const RADIAN = Math.PI / 180;
export const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
}: PIEChart) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

export interface ISelect {
  value: string;
}

export const myCoursesColumns: ColumnsType<DataType> = [
  {
    title: "Year",
    dataIndex: "year",
  },
  {
    title: "Term",
    dataIndex: "term",
  },
  {
    title: "Type",
    dataIndex: "type",
  },
  {
    title: "Code",
    dataIndex: "code",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Status",
    dataIndex: "status",
  },
  {
    title: "Type of Registration",
    dataIndex: "registrationType",
    render: (_, record) => (
      <>
        {record && record.costs?.length ? record.costs[0].registrationType : ""}
      </>
    ),
  },
];

export const setFiltersRender = (obj: any, form: any, student?: any) => {
  return (obj = {
    filterSet: [
      ...(form.filter
        ? [
            {
              filter: "Range Filter",
              startDate: form.from,
              endDate: form.to,
            },
          ]
        : []),
      ...(!form.filter
        ? [
            {
              filter: "Terms",
              year: form.year.join(", "),
              term: form.term.join(", "),
              ...(form.selection === "Course" && {
                course: form.course.join(", "),
              }),
              ...(form.selection === "Student" && { student: student.value }),
            },
          ]
        : []),
    ],
    ...obj,
  });
};
